import { buildApiUrl, fetchJSON, validateRequiredParams } from '../crm/crmApi';

export interface InvestorDashboardSummary {
  totals: {
    totalInvestors: number;
    prospecting: number;
    lateStage: number;
    closedWon: number;
    closedLost: number;
    winRate: number | null;
  };
  stageBreakdown: Record<string, number>;
  updatedAt: string;
}

export async function fetchInvestorDashboardSummary(
  organization_id: string
): Promise<InvestorDashboardSummary> {
  validateRequiredParams({ organization_id }, ['organization_id'], {
    service: 'investorCrm.dashboard.summary'
  });

  const url = buildApiUrl('/api/investor-crm/dashboard/summary', { organization_id });
  return fetchJSON<InvestorDashboardSummary>(url, {
    description: 'Fetch investor dashboard summary',
    context: { organization_id }
  });
}
